import Debug from './Debug';
import provideChart from '../ChartProvider';
export default provideChart(Debug);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jsx-highcharts/dist/es/components/Debug/index.js
// module id = 915
// module chunks = 0